import { useState } from "react";
import { useTranslation } from "react-i18next";

import { LogoType } from "../../../../commons/types/logo";
import Button from "../../components/Button/Button";
import LoadingIndicator from "../../components/LoadingIndicator/LoadingIndicator";
import Paragraph from "../../components/Paragraph/Paragraph";
import SplashScreenLayout from "../../components/SplashScreenLayout/SplashScreenLayout";
import useOnMount from "../../libs/hooks/use-on-mount";
import Logo from "../App/LogoPartial";

const SplashScreen = () => {
  const { t } = useTranslation(["commons"]);
  const [isTakingLonger, setIsTakingLonger] = useState(false);

  useOnMount(() => {
    const timeoutId = window.setTimeout(() => setIsTakingLonger(true), 10_000);
    return () => window.clearTimeout(timeoutId);
  });

  return (
    <SplashScreenLayout
      logo={<Logo type={LogoType.Claim} />}
      indicator={<LoadingIndicator />}
      hint={
        isTakingLonger && (
          <>
            <Paragraph>{t("commons:splashScreen.connectionTakingLonger")}</Paragraph>
            <Button onClick={() => window.location.reload()}>{t("commons:splashScreen.retry")}</Button>
          </>
        )
      }
    />
  );
};

export default SplashScreen;
